import {
  GET_LOOKUPTABLE_LOADING,
  GET_LOOKUPTABLE_SUCCESS,
  GET_LOOKUPTABLE_FAILURE,
} from '../actions/lookupTable';

const defaultState = {
  data: {},
  loading: false,
  error: false,
};

export default (state = defaultState, action) => {
  switch (action.type) {
    case GET_LOOKUPTABLE_LOADING:
      return {
        ...state,
        loading: true,
        error: false,
      };
    case GET_LOOKUPTABLE_FAILURE:
      return {
        ...state,
        loading: false,
        error: true,
      };
    case GET_LOOKUPTABLE_SUCCESS:
      return {
        data: action.payload,
        loading: false,
        error: false,
      };
    default:
      return state;
  }
};

export const loadingLookupTable = (state) => state.lookupTable.loading;
export const lookupTableSelector = (state) => state.lookupTable.data;
